import React, { useMemo } from 'react';
import Spinner from '../spinner/Spinner';
import styles from './button.module.scss';

type Props = {
  label: string;
  type?: 'submit' | 'button';
  size?: 'normal' | 'small' | 'extraSmall' | 'tiny';
  className?: string;
  title?: string;
  color?: 'orange' | 'green' | 'red'| 'white' | 'greenbackground' | 'lightgreen' | 'whitebackground' | 'blue';
  disabled?: boolean;
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLElement>) => void);
  outline?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  isLoading?: boolean;
  boldLabel?: string;
};

function Button(props: Props) {
  const {
    label,
    type = 'button',
    size = 'normal',
    className = '',
    color = 'orange',
    disabled = false,
    title = "",
    onClick,
    outline,
    leftIcon,
    rightIcon,
    isLoading,
    boldLabel
  } = props;

  const totalClass = useMemo(() => {
    const style = [styles.btn, styles[size]];

    if (outline) {
      style.push(styles[`${color}-outline`]);
    } else {
      style.push(styles[color]);
    }

    if (disabled) {
      style.push(styles.disabled);
    }

    if (isLoading) {
      style.push(styles.isLoading);
    }

    style.push(className);
    return style.join(' ');
  }, [size, color, disabled, className, outline, isLoading])

  return (
    <button
      onClick={onClick}
      title={title}
      disabled={disabled || isLoading}
      className={totalClass}
      type={type}
    >
      {leftIcon || isLoading || rightIcon ? (
        <div className={styles.row}>
          {leftIcon ? isLoading ? <Spinner width={20} height={20} /> : leftIcon : null}
          {label ? <div className={styles.label}>{label} {boldLabel ? <strong>{boldLabel}</strong> : ''}</div> : null}
          {rightIcon ? isLoading ? <Spinner width={20} height={20} /> : rightIcon : null}
        </div>
      ) : <div>{label} {boldLabel ? <strong>{boldLabel}</strong> : ''}</div>}
    </button>
  );
}

export default Button;